export const SUMMARY_INSIGHTS_CUSTOMER_VOLUME_REQUEST = 'SUMMARY_INSIGHTS_CUSTOMER_VOLUME_REQUEST';
export const SUMMARY_INSIGHTS_CUSTOMER_VOLUME_SUCCESS = 'SUMMARY_INSIGHTS_CUSTOMER_VOLUME_SUCCESS';
export const SUMMARY_INSIGHTS_CUSTOMER_VOLUME_FAILURE = 'SUMMARY_INSIGHTS_CUSTOMER_VOLUME_FAILURE';


export const SUMMARY_INSIGHTS_CUSTOMER_BY_TENURE_REQUEST = 'SUMMARY_INSIGHTS_CUSTOMER_BY_TENURE_REQUEST';
export const SUMMARY_INSIGHTS_CUSTOMER_BY_TENURE_SUCCESS = 'SUMMARY_INSIGHTS_CUSTOMER_BY_TENURE_SUCCESS';
export const SUMMARY_INSIGHTS_CUSTOMER_BY_TENURE_FAILURE = 'SUMMARY_INSIGHTS_CUSTOMER_BY_TENURE_FAILURE';


export const SUMMARY_INSIGHTS_CUSTOMERS_BY_TOTAL_SPEND_REQUEST = 'SUMMARY_INSIGHTS_CUSTOMERS_BY_TOTAL_SPEND_REQUEST';
export const SUMMARY_INSIGHTS_CUSTOMERS_BY_TOTAL_SPEND_SUCCESS = 'SUMMARY_INSIGHTS_CUSTOMERS_BY_TOTAL_SPEND_SUCCESS';
export const SUMMARY_INSIGHTS_CUSTOMERS_BY_TOTAL_SPEND_FAILURE = 'SUMMARY_INSIGHTS_CUSTOMERS_BY_TOTAL_SPEND_FAILURE';

export const SUMMARY_INSIGHTS_CUSTOMERS_BY_AVG_COVER_SIZE_REQUEST = 'SUMMARY_INSIGHTS_CUSTOMERS_BY_AVG_COVER_SIZE_REQUEST';
export const SUMMARY_INSIGHTS_CUSTOMERS_BY_AVG_COVER_SIZE_SUCCESS = 'SUMMARY_INSIGHTS_CUSTOMERS_BY_AVG_COVER_SIZE_SUCCESS';
export const SUMMARY_INSIGHTS_CUSTOMERS_BY_AVG_COVER_SIZE_FAILURE = 'SUMMARY_INSIGHTS_CUSTOMERS_BY_AVG_COVER_SIZE_FAILURE';

export const SUMMARY_INSIGHTS_CUSTOMERS_BY_LOYALTY_REQUEST = 'SUMMARY_INSIGHTS_CUSTOMERS_BY_LOYALTY_REQUEST';
export const SUMMARY_INSIGHTS_CUSTOMERS_BY_LOYALTY_SUCCESS = 'SUMMARY_INSIGHTS_CUSTOMERS_BY_LOYALTY_SUCCESS';
export const SUMMARY_INSIGHTS_CUSTOMERS_BY_LOYALTY_FAILURE = 'SUMMARY_INSIGHTS_CUSTOMERS_BY_LOYALTY_FAILURE';


export const DETAILED_INSIGHTS_CUSTOMER_DETAILS_RESET = 'DETAILED_INSIGHTS_CUSTOMER_DETAILS_RESET';
export const DETAILED_INSIGHTS_CUSTOMER_DETAILS_REQUEST = 'DETAILED_INSIGHTS_CUSTOMER_DETAILS_REQUEST';
export const DETAILED_INSIGHTS_CUSTOMER_DETAILS_SUCCESS = 'DETAILED_INSIGHTS_CUSTOMER_DETAILS_SUCCESS';
export const DETAILED_INSIGHTS_CUSTOMER_DETAILS_FAILURE = 'DETAILED_INSIGHTS_CUSTOMER_DETAILS_FAILURE';



export const DETAILED_INSIGHTS_SUMMARY_REQUEST = 'DETAILED_INSIGHTS_SUMMARY_REQUEST';
export const DETAILED_INSIGHTS_SUMMARY_SUCCESS = 'DETAILED_INSIGHTS_SUMMARY_SUCCESS';
export const DETAILED_INSIGHTS_SUMMARY_FAILURE = 'DETAILED_INSIGHTS_SUMMARY_FAILURE';


export const DETAILED_INSIGHTS_DINE_IN_REQUEST = 'DETAILED_INSIGHTS_DINE_IN_REQUEST';
export const DETAILED_INSIGHTS_DINE_IN_SUCCESS = 'DETAILED_INSIGHTS_DINE_IN_SUCCESS';
export const DETAILED_INSIGHTS_DINE_IN_FAILURE = 'DETAILED_INSIGHTS_DINE_IN_FAILURE';



export const DETAILED_INSIGHTS_OFF_PREM_REQUEST = 'DETAILED_INSIGHTS_OFF_PREM_REQUEST';
export const DETAILED_INSIGHTS_OFF_PREM_SUCCESS = 'DETAILED_INSIGHTS_OFF_PREM_SUCCESS';
export const DETAILED_INSIGHTS_OFF_PREM_FAILURE = 'DETAILED_INSIGHTS_OFF_PREM_FAILURE';



export const DETAILED_INSIGHTS_CUSTOMERS_ORDER_REQUEST = 'DETAILED_INSIGHTS_CUSTOMERS_ORDER_REQUEST';
export const DETAILED_INSIGHTS_CUSTOMERS_ORDER_SUCCESS = 'DETAILED_INSIGHTS_CUSTOMERS_ORDER_SUCCESS';
export const DETAILED_INSIGHTS_CUSTOMERS_ORDER_FAILURE = 'DETAILED_INSIGHTS_CUSTOMERS_ORDER_FAILURE';



export const DETAILED_INSIGHTS_LATEST_ORDER_REQUEST = 'DETAILED_INSIGHTS_LATEST_ORDER_REQUEST';
export const DETAILED_INSIGHTS_LATEST_ORDER_SUCCESS = 'DETAILED_INSIGHTS_LATEST_ORDER_SUCCESS';
export const DETAILED_INSIGHTS_LATEST_ORDER_FAILURE = 'DETAILED_INSIGHTS_LATEST_ORDER_FAILURE';


export const DETAILED_INSIGHTS_CUSTOMERS_TOP_FAV_ITEM_REQUEST = 'DETAILED_INSIGHTS_CUSTOMERS_TOP_FAV_ITEM_REQUEST';
export const DETAILED_INSIGHTS_CUSTOMERS_TOP_FAV_ITEM_SUCCESS = 'DETAILED_INSIGHTS_CUSTOMERS_TOP_FAV_ITEM_SUCCESS';
export const DETAILED_INSIGHTS_CUSTOMERS_TOP_FAV_ITEM_FAILURE = 'DETAILED_INSIGHTS_CUSTOMERS_TOP_FAV_ITEM_FAILURE';

export const DETAILED_INSIGHTS_CUSTOMERS_SEARCH = 'DETAILED_INSIGHTS_CUSTOMERS_SEARCH';

export const DETAILED_INSIGHTS_CUSTOMERS_SELECTED_EMPLOYEE = 'DETAILED_INSIGHTS_CUSTOMERS_SELECTED_EMPLOYEE';